import { Target } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BullseyeIcon = createLucideIcon(Target);
